// Store-wide config: flip STORE_OPEN to false to return to "Coming Soon" mode
export const STORE_OPEN = true;

export function fmt(price) {
  return `$${price.toFixed(2)} AUD`;
}
